import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Helper from "src/utils/Helper";
import { useEmbedDisplayOptions } from "src/views/hooks/useEmbedDisplayOptions";

const TreffasLogo = () => {
  const IsTablet = Helper.IsTablet();
  const { t } = useTranslation();
  const { hideFooter } = useEmbedDisplayOptions();

  if (hideFooter) {
    return null;
  }

  if (IsTablet) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
      }}
    >
      <noscript>
        <a href={window.location.href} target="_blank">
          Please fill out the form
        </a>
      </noscript>
      <div className="treffas-webform-container">
        <Typography
          variant={"caption"}
          sx={{
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "normal",
            color: "#878787",
          }}
        >
          {t("powered_by")}
        </Typography>{" "}
        <a
          className="treffas-webform-inner"
          rel="nofollow"
          href="https://treffas.com"
          target="_blank"
          style={{ color: "var(--color-black)" }}
        >
          Treffas
        </a>
      </div>
    </Box>
  );
};

export default TreffasLogo;
